import { useLocation, useNavigate } from "react-router-dom";
import InfoRow from "../../components/InfoRow";
import EnrollmentLetterField from "../../components/EnrollmentLetterField";
import UNAUTHORIZED from "../UNAUTHORIZED";

export default function StudentDone() {
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  const location = useLocation();
  const navigate = useNavigate();

  const element = location.state;

  return (
    <div>
      {user !== "user" && user !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div className="flex justify-center">
          <div
            className="lg:w-3/5 md:w-3/4 w-full border shadow
    flex flex-col p-3 rounded-lg bg-gray-50"
          >
            <div className="flex items-center justify-between">
              <span className="text-xl">Student Information</span>
              <span
                className="cursor-pointer rounded-full w-9 h-9 bg-red-400 text-white 
        flex items-center justify-center active:scale-90 hover:bg-red-500"
                onClick={() => navigate(-1)}
              >
                X
              </span>
            </div>
            <div className="flex flex-col m-3">
              <InfoRow data={element.id} label={"ID"} about="id" />
              <InfoRow
                data={element.full_name}
                label={"Full Name"}
                about="full_name"
              />
              <InfoRow data={element.email} label={"Email"} about="email" />
              <InfoRow
                data={element.address}
                label={"Address"}
                about="address"
              />
              <InfoRow
                data={element.postal_code}
                label={"Postal Code"}
                about="postal_code"
              />
              <InfoRow
                data={element.date_of_birth}
                label={"Data of Birth"}
                about="data_of_birth"
              />
              <InfoRow data={element.gender} label={"Gender"} about="gender" />
              <InfoRow data={element.phone} label={"Phone"} about="phone" />
              <InfoRow
                data={element.school_name}
                label={"School Name"}
                about="school_name"
              />
              <InfoRow
                data={element.test_center_name}
                label={"Test Center Name"}
                about="test_center_name"
              />
              <EnrollmentLetterField
                studentId={element.id}
                initialValue={element.enrollment_letter_received}
                fileName={element.enrollment_letter_file}
                assignedUser={element.enrollment_letter_assigned_user}
              />

              {/* <div className="p-2 border rounded mt-1 bg-blue-50">
                <InfoRow
                  data={element.act1_id}
                  label={"ACT 1 ID"}
                  about="act1_id"
                />
                <InfoRow
                  data={element.exam_name}
                  label={"Exam Name"}
                  about="exam_name"
                />
                <InfoRow
                  data={element.act1_score1}
                  label={"Score 1"}
                  about="act1_score1"
                />
                <InfoRow
                  data={element.act1_score2}
                  label={"Score 2"}
                  about="act1_score2"
                />
                <InfoRow
                  data={element.act1_score3}
                  label={"Score 3"}
                  about="act1_score3"
                />
                <InfoRow
                  data={element.act1_try_date1}
                  label={"Trial Date 1"}
                  about="act1_try_date1"
                />
                <InfoRow
                  data={element.act1_try_date2}
                  label={"Trial Date 2"}
                  about="act1_try_date2"
                />
                <InfoRow
                  data={element.act1_try_date3}
                  label={"Trial Date 3"}
                  about="act1_try_date3"
                />
                <InfoRow
                  data={element.act1_try_date4}
                  label={"Trial Date 4"}
                  about="act1_try_date4"
                />
                <InfoRow
                  data={element.act1_try_date5}
                  label={"Trial Date 5"}
                  about="act1_try_date5"
                />
                <InfoRow
                  data={element.act1_copy_number}
                  label={"Copies Number"}
                  about="act1_copy_number"
                />
                <InfoRow
                  data={element.act1_moe_copy}
                  label={"MOE Copies Number"}
                  about="act1_moe_copy"
                />
              </div> */}
              <div className="p-2 border rounded mt-1 bg-blue-50">
                {/* --- Static Info - These remain the same --- */}
                <InfoRow
                  data={element.act1_id}
                  label={"ACT 1 ID"}
                  about="act1_id"
                />
                <InfoRow
                  data={element.exam_name}
                  label={"Exam Name"}
                  about="exam_name"
                />

                {/* --- Dynamic Scores & Dates Section --- */}
                {/* 
                                                  We now loop through the 'scores' array.
                                                  The backend method returns this as an array of objects.
                                                  Each object represents one trial.
                                              */}
                {/* Render ACT1 scores grouped by trial_no from flat array */}
                {Array.isArray(element.act1_scores) && element.act1_scores.length > 0 ? (
                  (() => {
                    // Define the correct subject order
                    const SUBJECT_ORDER = ['English', 'Reading', 'Math', 'Science'];

                    // Group by trial_no robustly (avoid duplicate trials)
                    const grouped = new Map();
                    element.act1_scores.forEach((item) => {
                      const tno = item.trial_no;
                      if (!grouped.has(tno)) {
                        grouped.set(tno, {
                          trial_no: tno,
                          trial_id: item.trial_id,
                          trial_date: item.trial_date,
                          total_score: item.total_score,
                          subjects: []
                        });
                      }
                      grouped.get(tno).subjects.push({
                        subject_name: item.subject_name,
                        subject_score: item.subject_score
                      });
                    });

                    // Sort subjects within each trial by the correct order
                    grouped.forEach((trial) => {
                      trial.subjects.sort((a, b) => {
                        const orderA = SUBJECT_ORDER.indexOf(a.subject_name);
                        const orderB = SUBJECT_ORDER.indexOf(b.subject_name);
                        // If subject not found in order array, put it at the end
                        return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
                      });
                    });

                    // Render each trial only once
                    return Array.from(grouped.values()).map((scoreTrial, index) => (
                      <div key={scoreTrial.trial_no || index} className="p-2 my-2 border rounded bg-white shadow-sm">
                        <h4 className="font-bold text-md mb-2 text-blue-800 border-b pb-1">
                          Trial {scoreTrial.trial_no}
                        </h4>
                        <InfoRow
                          data={scoreTrial.total_score}
                          label={"Total Score"}
                          about={`act1_total_score_${scoreTrial.trial_no}`}
                        />
                        <InfoRow
                          data={scoreTrial.trial_date}
                          label={"Trial Date"}
                          about={`act1_trial_date_${scoreTrial.trial_no}`}
                        />
                        {/* If there are subject scores, display them */}
                        {Array.isArray(scoreTrial.subjects) && scoreTrial.subjects.length > 0 && (
                          <div className="mt-2 pl-4 border-l-2 border-blue-200">
                            <h5 className="font-semibold text-sm text-gray-600 mb-1">Subject Details:</h5>
                            {scoreTrial.subjects.map((subject, subIndex) => (
                              <InfoRow
                                key={subIndex}
                                data={subject.subject_score}
                                label={subject.subject_name}
                                about={`act1_subject_${String(subject.subject_name).toLowerCase()}_${scoreTrial.trial_no}`}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    ));
                  })()
                ) : (
                  <p className="p-2 text-gray-500">No trial scores found for ACT 1.</p>
                )}

                {/* --- Static Info - These remain the same --- */}
                <InfoRow
                  data={element.act1_copy_number}
                  label={"Copies Number"}
                  about="act1_copy_number"
                />
                <InfoRow
                  data={element.act1_moe_copy}
                  label={"MOE Copies Number"}
                  about="act1_moe_copy"
                />
              </div>
              {element.act2 && (
                <div className="p-2 border rounded mt-1 bg-green-50">
                  <InfoRow
                    data={element.act2_id}
                    label={"ACT 2 ID"}
                    about="act2_id"
                  />
                  <InfoRow
                    data={element.act2_score1}
                    label={"Score 1"}
                    about="act2_score1"
                  />
                  <InfoRow
                    data={element.act2_score2}
                    label={"Score 2"}
                    about="act2_score2"
                  />
                  <InfoRow
                    data={element.act2_score3}
                    label={"Score 3"}
                    about="act2_score3"
                  />
                  <InfoRow
                    data={element.act2_try_date1}
                    label={"Trial Date 1"}
                    about="act2_try_date1"
                  />
                  <InfoRow
                    data={element.act2_try_date2}
                    label={"Trial Date 2"}
                    about="act2_try_date2"
                  />
                  <InfoRow
                    data={element.act2_try_date3}
                    label={"Trial Date 3"}
                    about="act2_try_date3"
                  />
                  <InfoRow
                    data={element.subject1}
                    label={"Subject 1"}
                    about="subject1"
                  />
                  <InfoRow
                    data={element.subject2}
                    label={"Subject 2"}
                    about="subject2"
                  />
                  <InfoRow
                    data={element.subject3}
                    label={"Subject 3"}
                    about="subject3"
                  />
                  <InfoRow
                    data={element.act2_copy_number}
                    label={"Copies Number"}
                    about="act2_copy_number"
                  />
                  <InfoRow
                    data={element.act2_moe_copy}
                    label={"MOE Copies Number"}
                    about="act2_moe_copy"
                  />
                </div>
              )}
            </div>
            <div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
